import {Resource} from '@raison/types';
import React, {Fragment, ReactNode} from 'react';
import {RsnSkeleton, SkeletonProps} from './Skeleton';

export function AwaitResource<T>(props: AwaitResourceProps<T>): React.JSX.Element {
    if (!props.value.isSuccess) {
        return props.meanwhile || <RsnSkeleton {...props.skeleton} />;
    }
    return <Fragment>{props.render(props.value.data)}</Fragment>;
}

type AwaitResourceProps<T> = RenderProps<T> & MeanwhileProp & {value: Resource<T>};

type MeanwhileProp = {skeleton?: SkeletonProps; meanwhile?: never} | {meanwhile: React.JSX.Element};

type RenderProps<T> = AwaitingAnything<T>;

type AwaitingAnything<T> = {
    render: (value: T) => ReactNode;
};
